<template>
    <van-sticky>
      <van-tabs
        v-model="active"
        :ellipsis="false"
        line-width="20px"
        line-height="2px"
        title-active-color="#36B374"
        color="#36B374"
        @click="selectChange"
        class="my-tab"
      >
        <van-tab v-for="(item, index) in areaList" :key="index">
          <template #title>
            <div>
              <p align="center">{{ item.F_NAME }}</p>
              <p align="center">{{ item.count | numSeparate }}</p>
            </div>
          </template>
        </van-tab>
      </van-tabs>
    </van-sticky>
</template>
<script>
import Vue from 'vue';
import { Sticky } from 'vant';

Vue.use(Sticky);
export default {
    filters: {
      numSeparate(value) {
        var rag = /(\d)(?=(?:\d{3})+$)/g;
        if (!value) {
          return "0";
        } else {
          if ((value + "").indexOf(".") != -1) {
            let num = value.toString().split(".");
            if (num[1].length > 2) num[1] = "00";
            return num[0].replace(rag, "$1,") + "." + num[1];
          }
          return (value + "").replace(rag, "$1,");
        }
      },
    },
    name: "StickySelect",
    data() {
			return {
        active: this.activeIndex
			}
		},
    props: {
      areaList: {
        type: Array,
        default: [],
      },
      activeIndex: {
        type: Number,
        default: 0
      }
    },
    methods: {
      update(id){
        this.active = id;
      },
      selectChange(id) {
        this.$emit("change", this.areaList[id], this.active);
      }
    }
}
</script>

<style lang="less">
  .my-tab {
    .van-tabs__wrap {
      height: auto;
    }
    p:first-child {
      font-weight: 400;
      font-size: 14px;
      color: #171A1D;
      line-height: 16px;
      margin: 5px 0;
    }
    p:last-child {
      font-weight: 400;
      font-size: 12px;
      color: #71747A;
      line-height: 16px;
    }
    .van-tabs__line {
      bottom: 4px;
    }
    .van-tab--active {
      .van-tab__text {
        p:first-child{
          font-weight: 500;
          font-size: 14px;
          color: #229F60;
        }
        p:last-child {
          font-weight: 500;
          font-size: 12px;
          color: #36B374;
        }
      }
    }
  }
</style>